<template>
    <div>
        <card-header title='New Enrollment' icon="fa-plus"/>

        <card-body>
            <classic-enrollment-form :enrollment="enrollment" @loading="loading"/>
        </card-body>

        <card-footer class="pt-3 pb-3">
            <div class="columns">
                <div class="column has-text-right">
                    <b-button
                        type="is-primary"
                        size="is-small"
                        @click="submit"
                        :disabled="!enrollment.configSelect || !enrollment.units"
                    ><i class="fas fa-plus mr-2"></i>New Enrollment</b-button>
                </div>
            </div>
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardFooter from "@/TIER/components/CardFooter";

    import {client as http} from '../../http_client';
    import ClassicEnrollmentForm from "./ClassicEnrollmentForm";
    import moment from 'moment';

    export default {
        components: {ClassicEnrollmentForm, CardFooter, CardToolbar, CardBody, CardHeader},
        props: ['card', 'props'],
        data() {
            return {
                enrollment: {
                    courseSelect: null,
                    configSelect: null,
                    customName: '',
                    units: 0,
                    custom1: null,
                    custom2: null,
                    certificationID: 1,
                    unittype: 1,
                    stem_units: 0,
                    other_units: 0,
                    enrollDate: new Date(),
                    startedDate: new Date(),
                    disabled: 0,
                    completed: 0,
                    surveycompleted: 0,
                    readonly: 0,
                    manualaward: 0,
                    stem: 0,
                    planID: 0,
                    disabletext: '',
                    totalPaid: 0,
                    adminnotes: 'Enrolled Manually (Portal)',
                }
            }
        },
        methods: {
            submit: function() {

                console.log(this.enrollment);

                let payload = {
                    userID: parseInt(this.props.userId),
                    configID: this.enrollment.configSelect.id,
                    certificationID: this.enrollment.certificationID,
                    planID: this.enrollment.planID,
                    provider: this.enrollment.configSelect.provider,
                    units: this.enrollment.units,
                    unittype: this.enrollment.unittype,
                    customName: this.enrollment.customName.trim(),
                    disabled: this.enrollment.disabled,
                    disabletext: this.enrollment.disabletext,
                    enrollDate: (this.enrollment.enrollDate) ? moment(this.enrollment.enrollDate).format('YYYY-MM-DD HH:mm:ss') : null,
                    startedDate: (this.enrollment.startedDate) ? moment(this.enrollment.startedDate).format('YYYY-MM-DD HH:mm:ss') : null,
                    completedDate: (this.enrollment.completedDate) ? moment(this.enrollment.completedDate).format('YYYY-MM-DD HH:mm:ss') : null,
                    verifyDate: (this.enrollment.verifyDate) ? moment(this.enrollment.verifyDate).format('YYYY-MM-DD HH:mm:ss') : null,
                    totalPaid: this.enrollment.totalPaid,
                    completed: this.enrollment.completed,
                    surveycompleted: this.enrollment.surveycompleted,
                    readonly: this.enrollment.readonly,
                    manualaward: this.enrollment.manualaward,
                    stem: this.enrollment.stem,
                    stem_units: this.enrollment.stem_units,
                    other_units: this.enrollment.other_units,
                    adminnotes: this.enrollment.adminnotes
                };

                if (this.enrollment.custom1 && this.enrollment.custom1 !== 'N/A') payload.customName += ' ' + this.enrollment.custom1.trim();
                if (this.enrollment.custom2 && this.enrollment.custom2 !== 'N/A') payload.customName += ' ' + this.enrollment.custom2.trim();

                this.$emit('loading', true);
                http.post('enrollments/c/', payload, {force: true}).then(response => {
                    this.$reloadCard('course-enrollments');
                    this.$reloadCard('user-details');
                    this.$closeCard(this.card);
                }).catch(err => {

                });
            },
            loading: function(val) {
                this.$emit('loading', val);
            }
        }
    }
</script>
